import React from 'react';
import TextInput from 'views/components/TextInput';

const ContactForm = ({ formData, onChange }) => (
  <div className="input-grid question-grid">
    <label>
      <p>
        Name <span className="colored">*</span>
      </p>
      <TextInput className="lite-input" placeholder="Your full name" value={formData.contactName} onValueChange={onChange('contactName')} />
    </label>
    <label>
      <p>
        Email <span className="colored">*</span>
      </p>
      <TextInput
        className="lite-input"
        placeholder="your.email@company.com"
        type="email"
        value={formData.contactEmail}
        onValueChange={onChange('contactEmail')}
      />
    </label>
    <label>
      <p>
        Company <span className="colored">*</span>
      </p>
      <TextInput className="lite-input" placeholder="Your organization name" value={formData.contactCompany} onValueChange={onChange('contactCompany')} />
    </label>
  </div>
);

export default ContactForm;
